import axios from "axios";

const instance = axios.create({
  baseURL: "https://xpao3ln305.execute-api.us-east-1.amazonaws.com/BI/Power-BI-v2/",
  timeout: 120000
});

export default instance;